const swiperReviews = new Swiper('.swiper-reviews', {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,

    breakpoints: {
        768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 32,
        }
    },

    pagination: {
        el: '.swiper-reviews .hoox-swiper-dots',
        clickable: true,
    },

    navigation: {
        nextEl: '.swiper-reviews .hoox-swiper-next',
        prevEl: '.swiper-reviews .hoox-swiper-prev',
    },
});